import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function LiveStreamingVOD() {
    const billingBaseUrl = import.meta.env.VITE_BILLING_PORTAL_COM.startsWith('http') ? import.meta.env.VITE_BILLING_PORTAL_COM : `https://${import.meta.env.VITE_BILLING_PORTAL_COM}`;
  useEffect(() => {
    document.title = "Live Streaming VOD Platform | CMS, CDN & Monetization";
            sal();
          }, []);
  return (
    <>
    <Helmet>
        <title>Live Streaming VOD Platform | CMS, CDN & Monetization</title>
        <meta name="description" content="Deliver lag-free live streaming VOD with powerful infrastructure, multi-device apps, secure DRM, analytics, and high availability." />
        <meta name="keywords" content="Live Streaming Server, Video Streaming Server, Live Stream Server, Best Video Streaming Server, Live Streaming Server, Video Streaming Server Open Source, Live Video Streaming Server, Host Video Streaming Server, Video Streaming Server Cost, Live Streaming Server Cost, Web Video Streaming Server, Best Live Streaming Server, Best Server For Live Streaming, Live-Streaming-Vod, Vod Server" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/live-streaming-vod`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/live-streaming-vod`} />
        <meta property="og:title" content="Safe & Quick Video Streaming Servers: Best for Broadcast" />
        <meta property="og:description" content="Experience broadcasting superiority with high-speed, reliable video streaming servers. Crafted for excellent video delivery and enhanced customer satisfaction." />
    </Helmet>
    <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="text-center">
                        <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Live & Loaded, 24/7</span>
                        <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Turn Moments Into a Memory: With Live Streaming Server</h1>
                        <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">The right moment hits, the camera rolls, and there’s no other option. That is why our live streaming server is engineered for all those who perform under high pressure-creators, gamers, etc. We just make sure it never skips any climax.</p>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <a href={`${billingBaseUrl}/index.php?rp=/login`} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded billing-login-url btn-height" >
                                <span className="btn-arrow__text">
                                    Create Account
                                    <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

      <div className="pt-60 pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/because-Lag-Isnt-in.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                    <div className="col-lg-6 ipad-mt">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                From Live to Library
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                 “Lag” Isn’t in Your Dictionary
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Let’s be genuine-anyone can easily hit “Go Live,” but staying consistent under pressure? That’s the next step. With the help of Infinitive Host’s video streaming server, every single frame lands smoothly, and every millisecond counts. No more buffering. No more struggles. Just engaging, seamless streaming that keeps your target audience hooked in.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

    <section className="bg-white pt-100 pb-100">
        <div className="container">
            <div className="row align-items-center justify-content-between g-4">
                <div className="col-xl-6 col-lg-10">
                  <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Stream It Live. Serve It Forever.</small>
                    <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Live Streaming Server Meets Video Hosting.</h2>
                </div>
            </div>
            <div className="mt-8">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/all-eyes-on-you-everywhere.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">All Eyes on You, Everywhere</h6>
                            <p className="mb-0">Expand your live reach with trustworthy video hosting and streaming that always keeps you live on social media, OTT, etc.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/watch-tack-grow.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Watch. Track. Grow.</h6>
                            <p className="mb-0">With the help of our video streaming hosting, get valuable insights to track all views, improve reach, and keep your viewers engaged.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/go-live-stay-lit.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Go Live. Stay Lit.</h6>
                            <p className="mb-0">Buffering is not an option. Our web hosting for video streaming always brings high clarity and speed, even when views increase.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/we-watch-you-stream.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">We Watch, You Stream</h6>
                            <p className="mb-0">You create. We protect. Count on our live streaming server with round-the-clock expert support and constant monitoring.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="700" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/fully-in-control.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Fully in Control</h6>
                            <p className="mb-0">No more unnecessary limits on settings. With our media live streaming server, you call all the shots-stream your way, freely.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="800" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/scale-without-hassle.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Scale Without Hassle</h6>
                            <p className="mb-0">Stressed about overpaying as you grow? With our video streaming server, you scale only when you want-no waste of time, just success.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>


       <div className="container pt-100 pb-60">
        <div className="row">
            <div className="col-12">
                <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-10 col-lg-10 col-xl-5">
                            <h2 className="text-white">
                                Engage with Our Smarter Streaming Traits.
                            </h2>
                            <p className="mb-8 text-white text-opacity-75">
                                From demanded quality to complete access-our video streaming server always gives your stream everything it wishes for.
                                No more drama, just optimal performance.
                            </p>
                        </div>
                        <div className="col-xl-7">
                            <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/16-apps-included.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            16+ Apps Included
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Website <br/>
                                            Mobile Apps <br/>
                                            Smart TV Apps <br/>
                                            Xbox and PlayStation Apps <br/>
                                            Native Apps, Launch Instantly
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/powerful-it-infrastructure.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Powerful IT Infrastructure
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Powerful IT Infrastructure <br/>
                                            Cloud Infrastructure <br/>
                                            Global CDN <br/>
                                            Dedicated Servers <br/>
                                            DRM & Screen Recording Protection
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/video-cms.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Video CMS
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Click and Drag CMS <br/>
                                            Complete Meta-data Management <br/>
                                            No Code Structure <br/>
                                            Translation and Multiple Audio Support <br/>
                                            Global Payment Gateway Support
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/multiple-monetization.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Multiple Monetization
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Subscriptions (SVOD) <br/>
                                            Transactional / Pay Per View (PPV) <br/>
                                            Video Advertising (AVOD) <br/>
                                            Crowdfunding & Donation <br/>
                                            Pre-ordering
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/video-management.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Video Management
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Upload from any source <br/>
                                            Auto Transcoding & Encoding <br/>
                                            Multiple Video Profiles <br/>
                                            Auto-Bitrate Management <br/>
                                            Powerful & Lag free streaming
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/unique-features.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                           Unique Features
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Launch Instantly <br/>
                                            Completely Customizable <br/>
                                            Enterprise Integrations and APIs <br/>
                                            UGC Support <br/>
                                            DIY Approach
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                </div>
            </div>
        </div>
      </div>

      <section className="pt-60 pb-100">
          <div className="container">
              <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                  <div className="row justify-content-center">
                      <div className="col-xxl-7 col-xl-9">
                          <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                              <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                  <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                  <small className="text-primary fw-bold">Device-Friendly Streaming</small>
                              </div>
                          </div>
                          <div className="text-center mt-5">
                              <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Infinitive Host’s Live Streaming Server</h2>
                              <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Sick of glitches and low-quality streams stealing your user's attention? Step into smooth storytelling with our video stream server-where your voice is not breaking, your content reach is worldwide, and every single moment hits perfectly.</p>
                          </div>
                          <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                              <img src="images/vod-streaming.gif" alt="image" className="img-fluid" />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>

      <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/support-so-top-notch.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                    <div className="col-lg-6 ipad-mt">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Support That Never Ghosts
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Support So Top-Notch, Even Your Stream Feels It
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Tired of your live streaming server that sometimes leaves you off mid-stream? Don’t worry, we’re there just for you. With our video streaming hosting, you constantly stay live, loud, and struggle-free.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                No More Lag in Your Streams
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Let Your Stream Flow, Not Buffer.
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Stuck with glitchy streams ruining the live? Our streaming video hosting and robust video stream server bring high-resolution video for your webinars, classes, and many more, every stream hits hard.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate ipad-mt" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/let-your-stream- flow.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="bg-white pt-100 pb-100">
        <div className="container ">
            <div className="row">
                <div className="col-12">
                    <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-xxl-8 feature-card__list m-auto">
                                    <div className="feature-card__is rounded-3">
                                    <div className="mb-4">
                                        <img src="images/stream-your-story.webp" alt="image" className="img-fluid" />
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-5">
                                <h2 className="text-white">
                                    Stream Your Story
                                </h2>
                                <p className="mb-8 text-white text-opacity-75">
                                    Ready to Grab the Attention and Hearts of Millions? Let’s Go Live!
                                </p>
                                <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded me-sm-4 m-auto btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                    <i className="las la-comments"></i>
                                    </span>
                                    <span className="btn-arrow__text">+91-7737300013
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    </span>
                                </Link>
                                <Link to="#" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded me-sm-2 m-auto mt-sm-0 mt-4 open-live-chat btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                    <i className="las la-comments"></i>
                                    </span>
                                    <span className="btn-arrow__text">Talk to an Expert
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                        <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  );
}
